/**
 * "Fake" translation function for use in route titles, which cannot use useTranslation (set outside of React context)
 * This makes sure that the i18n linter registers route titles as used translation keys.
 * Real translation of route titles happens in useSetRouteTitle.
 */
export const t = (key: string): string => key;
